/* eslint-disable import/no-extraneous-dependencies -- This error is suppressed pending utils pr */
import genericDomainsList from './genericDomainsList.json'

// Function to check if an email input is in a list of generic email domains, used when determining
// which fields to display
export const isGenericEmail = (email = '') => (genericDomainsList.includes(email.substring(email.indexOf('@') + 1)))

// Takes in the entirety of the section config input and returns an object
// that can be used to initialise Formik's initial state
export const prepareSectionMapAsInitialEntries = (sectionMap) => Object.fromEntries(
  sectionMap
    .map((item) => item.inputs?.map((inner) => inner.name))
    .flat()
    .filter(Boolean)
    .map((name) => [name, '']),
)

export const extractLeadAttributesFromValues = (fullName, email, companyName = '') => {
  const firstName = fullName
    ? fullName.split(' ')[0]
    : email // Assume this is `steven.johns@email.com`
      .split('@')[0] // Extract the username -> `steven.johns`
      .replace(/^./, (str) => str.toUpperCase()) // Upper the first character -> `Steven.johns`
      .replace(/\./g, ' ') // Replace any dots with spaces -> `Steven johns`
      .split(' ')[0] // Split on spaces and return first -> `Steven`

  const lastName = fullName?.split(' ').length > 1
    ? fullName
      .split(' ')
      .slice(-1)[0]
      .replace(/^./, (str) => str.toUpperCase())
    : ''

  const company = companyName || email.substring(email.indexOf('@') + 1)

  return { firstName, lastName, company }
}
